export default "__VITE_ASSET__BdwulgFj__"